module.exports = __webpack_public_path__ + "../resources/img/ic_play_disable_dark.f1132ef5.svg";